module.exports = __webpack_public_path__ + "static/media/redWaglLogo.297fef4c.svg";